import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { denormalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { getDataEntities } from '@wix/da-shared-react/pkg/redux/entities/selectors';
import { GroupAdminsModuleDataResultsSchema } from '../../../schemas/modules';
import { getModuleData } from '../../../selectors/modules';
import { Props as WidgetBoxProps } from '../../UserWidgets/_partials/WidgetBox';
import { Props as AdminsProps } from './Admins';

type Props = AdminsProps & WidgetBoxProps;
type StateProps = Pick<Props, 'isOwner' | 'profileOwnerUser'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  const results = denormalize(
    moduleData.results,
    GroupAdminsModuleDataResultsSchema,
    getDataEntities(state)
  );
  return {
    ...moduleData,
    results,
    isOwner: isCurrentUserProfileOwner(state),
    profileOwnerUser: getProfileOwnerUser(state),
  };
};

export default connect(mapStateToProps);
